import * as yup from "yup";

import { CustomerCardFormType } from "@/components/features/ToDos/CustomerCardPage/formType";
import { Shape } from "@/core/yup";

export const formSchemaCompanyInfo = yup.object<{}, Shape<MyBrokerApi.CompanyInfo>>({
    bceNumber: yup.string().bceNumber(),
    establishmentNumber: yup.string().bceNumber(),
});

export const formSchemaMoralDetails = yup.object<{}, Shape<CustomerCardFormType>>({
    companyInfo: yup.object().when("isPhysicalPerson", {
        is: false,
        then: () => formSchemaCompanyInfo,
    }),
});
